import React from 'react';
import { Navigate } from 'react-router-dom';

const CustomerPrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  // Check if user is logged in and is a customer
  if (!token || user.user_type !== 'customer') {
    return <Navigate to="/login" state={{ message: 'Lütfen müşteri hesabınızla giriş yapın.' }} />;
  }
  
  return children;
};

export default CustomerPrivateRoute; 